export default {
    name: 'contactSection',
    title: 'Contact Section',
    type: 'document',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'string',
            initialValue: 'Contact Us'
        },
        {
            name: 'description',
            title: 'Description',
            type: 'text',
            initialValue: 'Embark on your immigration journey with confidence. Contact Bansah and Associates today to schedule a consultation with our dedicated team of immigration experts.'
        },
    ],
    preview: {
        select: {
            title: 'title'
        },
        prepare({ title }) {
            return {
                title: title || 'Contact Section'
            }
        }
    }
} 